module.exports = __webpack_public_path__ + "static/media/copy-white.40a5944a.png";